import { render, staticRenderFns } from "./benefits-tier-rewards-grid.vue?vue&type=template&id=5669a0d5&scoped=true"
import script from "./benefits-tier-rewards-grid.vue?vue&type=script&lang=js"
export * from "./benefits-tier-rewards-grid.vue?vue&type=script&lang=js"
import style0 from "./benefits-tier-rewards-grid.vue?vue&type=style&index=0&id=5669a0d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5669a0d5",
  null
  
)

export default component.exports